import React, { useContext } from "react";
import { Api } from "./types";

const Context = React.createContext<Api>(null!);

export const useApi = () => useContext(Context);

export default Context;
